import { useState, useEffect } from 'react';
import { useSession } from '../contexts/SessionContext';
import { useFlow } from '../contexts/FlowContext';
import SecureSessionService from '../services/session/SecureSessionService';
import { ORIGINAL_CLIENT_REDIRECT_URL } from '../config';
import { getLogoutRedirectUrl } from '../utils/nativeApp';

interface UseSessionExpiryReturn {
  isSessionExpired: boolean;
  handleSessionExpired: () => void;
}

export const useSessionExpiry = (): UseSessionExpiryReturn => {
  const { sessionData, clearSession, forceSessionExpired } = useSession();
  const { resetFlow, getFlowData } = useFlow();
  const isNativeApp = getFlowData('device') === 'native_app';
  const [isSessionExpired, setIsSessionExpired] = useState(false);

  useEffect(() => {
    if (forceSessionExpired) {
      setIsSessionExpired(true);
      return;
    }

    if (!sessionData) return;

    const timeUntilExpiry = sessionData.expiresAt - Date.now();

    if (timeUntilExpiry <= 0) {
      setIsSessionExpired(true);
      return;
    }

    const timeout = setTimeout(() => {
      setIsSessionExpired(true);
    }, timeUntilExpiry);

    return () => clearTimeout(timeout);
  }, [sessionData, forceSessionExpired]);

  const handleSessionExpired = () => {
    resetFlow();
    SecureSessionService.clearSession();
    const redirectUrl = isNativeApp
      ? getLogoutRedirectUrl()
      : ORIGINAL_CLIENT_REDIRECT_URL;
    
    window.location.replace(redirectUrl);
  };

  return {
    isSessionExpired,
    handleSessionExpired
  };
};
